import { getTouchedFieldError, getFieldError } from "./Form";

const insuredPaymentFields = [
  "insuredFirstName",
  "insuredCompany",
  "insuredLastName",
  "insuredAddress",
  "insuredCity",
  "insuredState",
  "insuredZip",
  "contactPhone",
  "contactEmail",
  "consentConfirmed",
  "contactFirstName",
  "contactLastName",
  "northDakotaDisclosure",
];

export const getIsPaymentPageValid = (state) => {
  const { consentConfirmed, northDakotaDisclosure } =
    state.form.application.values;

  let northDakotaDisclosureValid = true;
  if (isVenueInNorthDakota(state) && !northDakotaDisclosure) {
    northDakotaDisclosureValid = false;
  }

  const insuredPaymentFieldsValid = !insuredPaymentFields.some((fieldName) =>
    Boolean(getFieldError(fieldName)(state)),
  );

  return (
    consentConfirmed && northDakotaDisclosureValid && insuredPaymentFieldsValid
  );
};

export const isVenueInNorthDakota = (state) => {
  return state.formPage.venue?.selectedPlaceAddressComponents?.state === "ND";
};

export const insuredPaymentHasErrors = (state) =>
  insuredPaymentFields.some((fieldName) =>
    Boolean(getTouchedFieldError(fieldName)(state)),
  );
